/**
 * @generated SignedSource<<7f659435e18e1b2c150ceb438d9b3aaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTypesDialogIssueTypes$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly isEnabled: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"IssueTypeEntry">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "IssueTypesDialogIssueTypes";
};
export type IssueTypesDialogIssueTypes$key = {
  readonly " $data"?: IssueTypesDialogIssueTypes$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypesDialogIssueTypes">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTypesDialogIssueTypes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isEnabled",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "IssueTypeEntry"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IssueTypeConnection",
  "abstractKey": null
};

(node as any).hash = "ce08c8224427fb7dcbbb27233f4fcb33";

export default node;
